export default __webpack_public_path__ + "static/mobile-application-development-peerbits-bc66ce0651568aad75b209b6d45f9163.png";